import ListProcesses from "@/views/packing_house/production/packing_by_pallet/ListProcesses.vue";
import ShowProcess from "@/views/packing_house/production/packing_by_pallet/ShowProcess.vue";
import ShowProcessContainers from "@/components/views/packing_house/production/packing_by_pallet/show_process/Containers.vue";
import ShowProcessPackageGroupsFromStock from "@/components/views/packing_house/production/packing_by_pallet/show_process/PackageGroupsFromStock.vue";
import ShowContainer from "@/views/packing_house/production/packing_by_pallet/ShowContainer.vue";
import ShowContainerResume from "@/components/views/packing_house/production/packing_by_pallet/show_container/Container.vue";
import ShowContainerPallets from "@/components/views/packing_house/production/packing_by_pallet/show_container/Pallets.vue";
import AssignPackageGroup from "@/views/packing_house/production/packing_by_pallet/AssignPackageGroup.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "ph",
  role: "production",
  permission: "packing_by_pallet",
});

export default [
  {
    path: "/ph/:packing_house_id/production/packing_by_pallet/list_processes",
    name: routeName("list_processes"),
    component: ListProcesses,
    props: true,
    meta: META,
  },
  {
    path: "/ph/:packing_house_id/production/packing_by_pallet/show_process/:packing_house_process_id",
    name: routeName("show_process"),
    redirect: { name: routeName("show_process_containers") },
    component: ShowProcess,
    props: true,
    meta: META,
    children: [
      {
        path: "containers",
        name: routeName("show_process_containers"),
        component: ShowProcessContainers,
        props: true,
        meta: META,
      },
      {
        path: "packages_from_stock",
        name: routeName("show_process_package_groups_from_stock"),
        component: ShowProcessPackageGroupsFromStock,
        props: true,
        meta: META,
      },
    ],
  },
  {
    path: "/ph/:packing_house_id/production/packing_by_pallet/show_container/:packing_house_process_id/:container_id",
    name: routeName("show_container"),
    redirect: { name: routeName("show_container_pallets") },
    component: ShowContainer,
    props: true,
    meta: META,
    children: [
      {
        path: "resume",
        name: routeName("show_container_resume"),
        component: ShowContainerResume,
        props: true,
        meta: META,
      },
      {
        path: "pallets",
        name: routeName("show_container_pallets"),
        component: ShowContainerPallets,
        props: true,
        meta: META,
      },
    ],
  },
  {
    path: "/ph/:packing_house_id/production/packing_by_pallet/assign_package_group/:packing_house_process_id/:container_id",
    name: routeName("assign_package_group"),
    component: AssignPackageGroup,
    props: true,
    meta: META
  }
]
